import styled from 'styled-components';

import { Box } from 'approot/shared/design-system/box/box.style';
import { grey1, grey5 } from 'approot/shared/styles/colours.style';
import {
  borderRadius8,
  boxShadowBlack8,
} from 'approot/shared/styles/borders.style';
import { rem } from 'approot/shared/style';
import { ToolSizeContainerRange } from './tool-size.style';

export const ToolTextOptionsContainer = styled.div`
  ${boxShadowBlack8}
  border-radius: ${rem(borderRadius8)};
  background-color: ${grey1};
  position: relative;
  width: 190px;
  display: flex;
  justify-content: end;

  /* Override the default styles of the tool size component */
  ${ToolSizeContainerRange} {
    box-shadow: none;
    position: absolute;
    top: 76px;
    left: -71px;
    width: 210px;
  }
`;

export const ToolTextOptions = styled(Box).attrs({
  $flexDirection: 'column',
})`
  padding: 8px;
  border-left: 1px solid ${grey5};
  width: 120px;
`;
